import Rest from '../Rest'

export default class CalendarTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/calendar_types'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
